import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[selectFocusTrapItem]',
})
export class SelectFocusTrapItemDirective {
  @Input() public selectFocusTrapItem = "";

  public focus(): void {
    this.elementRef.nativeElement?.focus();
  }

  constructor(private elementRef: ElementRef<HTMLElement>) {}
}
